import React, { Component } from "react";

import * as apiConstant from "../../api/apiConstant";
import store from "../../store/configureStore";
import { lang } from "../../config/lang";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { addNotification } from "../../actions/notificationAction";
import leadershipApi from "../../api/leadershipApi";
import $ from "jquery";

/****************************************
    Component for content of a revolution page
    @author  UYM
    @date    2020.05.14
    @version 0.1    
 ******************************************/
class ArticleBlock extends Component {
  constructor(props) {
    super(props);

    var date = new Date(Date.parse(this.props.date));
    var d = date.getDate();
    var m = date.getMonth() + 1;

    date = date.getFullYear() + "." + m + "." + d + ".";

    this.state = {
      date: date,
    };

    this.getTitleByLang = this.getTitleByLang.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    window.gallery();
    window.checkSize();
    window.onSetClass("dark");
    $(".leadership-link").click(function() {
      let $url = $(this);
      let t, l, w, h;
      w = window.innerWidth * 0.988;
      h = window.innerHeight * 1.273;
      t = (window.innerHeight - h) / 2;
      l = (window.innerWidth - w) / 2;
      // t=(window.innerWidth-w)/2;
      const newwindow = window.open(
        $url.attr("data-url"),
        "로동신문",
        "width=" +
          w +
          ",height=" +
          h +
          ",left=" +
          l +
          ",top=" +
          t +
          ",adressbar=0, scrollbars=yes, menubar=no, directories=no, location=no,status=0,resizable=no"
      );
      newwindow.window.addEventListener(
        "mousewheel",
        function(e) {
          if (e.ctrlKey == true || e.metaKey == true) e.preventDefault();
        },
        { capture: false, passive: false, once: false }
      );
      newwindow.document.addEventListener("keydown", function(e) {
        if (
          e.keyCode == 17 ||
          e.keyCode == 187 ||
          e.keyCode == 189 ||
          e.keyCode == 109 ||
          e.keyCode == 107
        ) {
          e.preventDefault();
          return false;
        }
      });
    });
  }

  componentWillUnmount() {}

  componentWillUpdate() {}

  componentDidUpdate() {}

  componentWillReceiveProps() {
    // this.getTitleByLang();
  }

  getTitleByLang() {
    leadershipApi.getTitleByLang(this.props.id).then((json) => {
      if (json.status === 200 && json.data) {
        this.setState({
          title: json.data.title,
        });
      } else {
        if (json.status === 620) {
          store.dispatch(addNotification(`${lang("access_deny")}`, "error"));
        } else {
          store.dispatch(addNotification(`${lang("server_err")}`, "error"));
        }
      }
    });
  }

  render() {
    return (
      <div className="article clearfix">
        <div className="row">
          <div className="col-md-10">
            <a
              className="leadership-link"
              data-url={`/revolution/${this.props.id}`}
              dangerouslySetInnerHTML={{
                __html:
                  this.props.pKey +
                  ". " +
                  (this.props.title === null || this.props.title === undefined
                    ? ""
                    : this.props.title),
              }}
            ></a>
            <div data-lightbox="gallery">
              {this.props.images.map((image, key) => (
                <span
                  key={key}
                  to={`${apiConstant.tablet(
                    this.props.business,
                    this.props.id,
                    image.name
                  )}`}
                  data-lightbox="gallery-item"
                  className="leadership-view"
                >
                  &nbsp;&nbsp;[
                  <i className="icon icon-camera"></i>]
                </span>
              ))}
            </div>
          </div>
          <div
            className="col-md-2 leadership-link"
            data-url={`/revolution/${this.props.id}`}
          >
            <a
              data-url={`/revolution/${this.props.id}`}
              className="float-right"
            >
              {this.state.date}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(ArticleBlock);
